import { operators } from '@/content/site';
import { ScrollReveal } from '@/components/ScrollReveal';
import { Section } from '@/components/Section';
import './Operators.css';

export function Operators() {
  return (
    <Section id="operadores" label="Para tu equipo" title={operators.title} lead={operators.lead}>
      <div className="operators-grid">
        {operators.items.map((item, i) => (
          <ScrollReveal key={item.title} delay={i * 80}>
            <article className="glass-card operators-card">
              <h3>{item.title}</h3>
              <p>{item.body}</p>
            </article>
          </ScrollReveal>
        ))}
      </div>
    </Section>
  );
}
